import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Select } from 'antd'

const Option = Select.Option

class SearchDropdown extends Component {

  onSelect = (value) => 
    this.props.onSwitchSearchfilter(value)

  render() {
    const { columns, filter } = this.props;
    const options = [{ value: '', display: 'Select' }]

    columns.forEach(col => {
      if(col.dataIndex !== "projectUUID" && col.dataIndex !== "lineItemUUID"){
        options.push({
          value: typeof col.dataIndex === "function" ? col.id : col.dataIndex,
          display: col.title || col.dataIndex
        })
      }
    });

    const opt = options.map(opt => {
      return (
        <Option key={opt.value} value={opt.value}>
          {opt.display}
        </Option>
      )
    })

    return (
      <Select 
        value={filter.selectedSearchField}
        onChange={this.onSelect}
        className="filter-select"
      >
        {opt}
      </Select>
    )
  }
}

function mapStateToProps(state) {
  const { filter } = state
  return { filter }
}

function mapDispatchToProps(dispatch) {
  return {}
}

SearchDropdown.defaultProps = {
  onSelect: () => {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchDropdown)